import styled from 'styled-components'

export const InputField = styled.div`
  width: 100%;
  direction: rtl;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  position: relative;
`

export const Inputbox = styled.textarea`
  border: solid ${(props) => props.theme.colors.lightRed};
  border-radius: 1.25rem;
  outline: none;
  padding: 0.5rem;
  resize: none;
  min-height: 6rem;
  font-size: large;
  line-height: 2rem;
`
